<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'LoginCallback',
  async beforeMount () {
    try {
      console.log('Starting Login redirect handle');      
      await this.$auth.handleLoginRedirect();
      console.log('Finish Login redirect handle, clearing transaction storage and refreshing to stabilize session');
      sessionStorage.removeItem('okta-transaction-storage');
      // eslint-disable-next-line
      window.location.href = window.location.href;
    } catch (error) {
      console.log('Error during login callback');
      console.error(error);
      if (error.message === 'Unable to retrieve OAuth redirect params from storage') {
        console.log('We caught the storage sync error, forcing refresh');
        sessionStorage.removeItem('okta-transaction-storage');
        // eslint-disable-next-line
        window.location.href = window.location.href;
      }
      const isInteractionRequiredError = this.$auth.isInteractionRequiredError || this.$auth.idx.isInteractionRequiredError;
      if (isInteractionRequiredError(error)) {
        const { onAuthResume, onAuthRequired } = this.$auth.options;
        const callbackFn = onAuthResume || onAuthRequired;
        if (callbackFn) {
          callbackFn(this.$auth);
          return;
        }
      }
      let loginError = '0';
      if (error.message?.includes?.('not assigned to the client application')) {
        loginError = 'not-authorized';
      }
      this.$router.replace({path: `/login?err=${loginError}`});
    }
  },
  mounted() {
    console.log('Mounted callback page');
    const tm = this.$auth.tokenManager;
    if (!this.$auth.isLoginRedirect()) {
      console.log('Not in login redirect, redirecting...');
      this.$router.replace({path: '/'});
    }
    this.$router.replace({path: `/login` });
  },
  render() { 
    return this.$scopedSlots.default && this.$scopedSlots.default({});
  }
});
</script>
